import CustomButton from "../../components/form/CustomButton";

export const Columns = (
  openModalAdd,
  setModalConfirm,
  modalConfirm,
  modalFiles,
  setModalFiles,
  completeFinishLoad,
  loadinStatus
) => {
  return [
    {
      id: "order",
      name: "WORK ORDER",
      selector: (row) => `${row.id}${row.client?.id ?? ""}`,
      minWidth: "140px",
      cell: (row) => (
        <div className="flex flex-col">
          <span className="text-xs font-semibold text-cs-dark">
            #{row.id}
          </span>
          {row.client?.id && (
            <span className="text-[10px] text-cs-muted">
              Client ID: {row.client.id}
            </span>
          )}
        </div>
      ),
    },
    {
      id: "truck_triler",
      name: "TRUCK / TRAILER",
      selector: (row) => row.truck_triler,
      minWidth: "150px",
      cell: (row) => (
        <span className="text-xs text-cs-dark">
          {row.truck_triler || "-"}
        </span>
      ),
    },
    {
      id: "client",
      name: "CLIENT",
      selector: (row) => row.client?.company_name,
      minWidth: "180px",
      cell: (row) => (
        <div className="flex flex-col">
          <span className="text-xs font-medium text-cs-dark">
            {row.client?.company_name || "-"}
          </span>
          {row.client?.contact_name && (
            <span className="text-[10px] text-cs-muted">
              {row.client.contact_name}
            </span>
          )}
        </div>
      ),
    },
    {
      id: "pick_up",
      name: "PICK UP DATE",
      selector: (row) => row.pick_up_date,
      minWidth: "120px",
      cell: (row) => (
        <span className="text-[10px] text-cs-muted">
          {row.pick_up_date || "-"}
        </span>
      ),
    },
    {
      id: "delivery_date",
      name: "DELIVERY DATE",
      selector: (row) => row.delivery_date,
      minWidth: "120px",
      cell: (row) => (
        <span className="text-[10px] text-cs-muted">
          {row.delivery_date || "-"}
        </span>
      ),
    },
    {
      id: "evidences",
      name: "EVIDENCES",
      minWidth: "110px",
      cell: (row) => (
        <CustomButton
          type="button"
          onClick={() =>
            setModalFiles({
              ...modalFiles,
              show: true,
              item: row,
            })
          }
          className="
            w-full
            px-3 py-1.5
            rounded-full
            bg-cs-primary-soft
            text-[10px] font-medium text-cs-dark
            hover:bg-cs-primary-hover/15
            transition-all
          "
        >
          Files
        </CustomButton>
      ),
    },
    {
      id: "action",
      name: "ACTION",
      minWidth: "180px",
      cell: (row) => (
        <div className="flex flex-col gap-1">
          {row.can?.finish && (
            <CustomButton
              loading={loadinStatus}
              textLoad="Processing"
              type="button"
              title="The operator finished all stops"
              onClick={() => completeFinishLoad(row.id, 29)}
              className="
                flex items-center justify-center
                w-full px-2 py-1.5
                rounded-full
                bg-cs-primary-soft
                text-[10px] font-medium text-cs-primary-dark
                hover:bg-cs-primary-hover/15
                transition-all
              "
            >
              Finished
            </CustomButton>
          )}

          {row.can?.complete && (
            <CustomButton
              loading={loadinStatus}
              textLoad="Processing"
              type="button"
              onClick={() => completeFinishLoad(row.id, 30)}
              className="
                flex items-center justify-center
                w-full px-2 py-1.5
                rounded-full
                bg-cs-surface-alt
                text-[10px] font-medium text-cs-primary-dark
                hover:bg-cs-primary-soft
                transition-all
              "
            >
              Completed
            </CustomButton>
          )}
        </div>
      ),
    },
    {
      id: "status",
      name: "STATUS",
      minWidth: "110px",
      cell: (row) => (
        <span
          className="
            inline-flex items-center
            px-2 py-1
            rounded-full text-[10px] font-medium
            text-cs-dark
            shadow-sm
          "
          style={{ background: row.status?.color || "#6B7280" }}
        >
          <span className="w-1.5 h-1.5 rounded-full bg-white mr-1.5" />
          {row.status?.name || "Unknown"}
        </span>
      ),
    },
    {
      id: "actions",
      name: "",
      button: true,
      minWidth: "110px",
      cell: (row) => {
        const canDelete = !!row.can?.delete;

        return (
          <div className="flex items-center justify-end gap-2">
            {/* Edit */}
            <button
              type="button"
              onClick={() => openModalAdd(row)}
              className="
                p-1.5 rounded-lg
                hover:bg-cs-primary-soft
                text-cs-dark hover:text-cs-primary
                transition-colors
              "
              title="Edit load"
            >
              <i className="fas fa-pen text-[14px]" />
            </button>

            {/* Delete */}
            <button
              type="button"
              onClick={() =>
                canDelete &&
                setModalConfirm({
                  ...modalConfirm,
                  show: true,
                  id: row.id,
                })
              }
              disabled={!canDelete}
              className={`
                p-1.5 rounded-lg transition-colors
                ${
                  canDelete
                    ? "hover:bg-cs-primary-soft"
                    : "opacity-40 cursor-not-allowed"
                }
              `}
              title="Delete load"
            >
              <i
                className={`
                  fas fa-trash text-[14px]
                  ${
                    canDelete
                      ? "text-cs-danger"
                      : "text-cs-muted"
                  }
                `}
              />
            </button>
          </div>
        );
      },
    },
  ];
};
